import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "b-notification-page" }
const _hoisted_2 = {
  ref: "leftBar",
  class: "b-notification-page__left-bar"
}
const _hoisted_3 = { class: "b-notification-page__left-bar__inner" }
const _hoisted_4 = { class: "b-notification-page__inner" }
const _hoisted_5 = { class: "b-notification-page__nav" }
const _hoisted_6 = { class: "b-notification-page__inner-activities h-flex h-flex-dir-column h-flex-center" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "h-font-18 h-fw-500 h-opacity-0_5" }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "b-notification-page__avatar__color--gradient h-mv-15"
}
const _hoisted_12 = { class: "h-flex h-flex-dir-column h-flex-justify-center h-ml-20 h-mv-10" }
const _hoisted_13 = { class: "h-font-16 h-fw-700 h-mv-5" }
const _hoisted_14 = { class: "h-font-16 h-fw-400" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "b-notification-page__inner-activities--time h-m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftBarMenu = _resolveComponent("LeftBarMenu")!
  const _component_FinalePopup = _resolveComponent("FinalePopup")!
  const _component_AddOrEditEventPopup = _resolveComponent("AddOrEditEventPopup")!
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!
  const _component_WorkerAvatar = _resolveComponent("WorkerAvatar")!
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwPagination = _resolveComponent("FwPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_LeftBarMenu)
      ])
    ], 512),
    (_ctx.showInfoPopup)
      ? (_openBlock(), _createBlock(_component_FinalePopup, {
          key: 0,
          header: `POPUP.FINALY.EVENT.DELETED`,
          subMessage: `POPUP.FINALY.EVENT.DELETED.TEXT`,
          eventTitle: _ctx.$t(_ctx.getActivitiesTitle(_ctx.activityTitle)),
          showImage: false,
          onClose: _ctx.closePopup
        }, null, 8, ["eventTitle", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showPreview)
      ? (_openBlock(), _createBlock(_component_AddOrEditEventPopup, {
          key: 1,
          users: _ctx.users,
          loading: _ctx.loadingEvent,
          event: _ctx.addEventData,
          eventUserId: _ctx.userIdAvatar,
          showAvatar: true,
          editDeleteEvent: false,
          originValue: `unavailability`,
          onClose: _ctx.closePopup
        }, null, 8, ["users", "loading", "event", "eventUserId", "onClose"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('NOTIFICATION.ACTIVITIES.TITLE')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
              key: 0,
              colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
              class: "h-flex-center loader",
              isActive: _ctx.loading,
              className: "h-p-20"
            }, null, 8, ["isActive"]))
          : (!_ctx.activitiesArray.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('NOTIFICATION.NO.ACTIVITIES.TITLE')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activitiesArray, (activity) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass([{"b-notification-page__inner-activities--block-unread": !activity.read}, "b-notification-page__inner-activities--block h-flex h-flex-justify-start h-pointer"]),
                    onClick: ($event: any) => (_ctx.postActivityRead(activity))
                  }, [
                    (_ctx.users.length !== 0 && _ctx.getWorkerAvatar(activity.creator_id))
                      ? (_openBlock(), _createBlock(_component_WorkerAvatar, {
                          key: 0,
                          class: "h-mv-15",
                          hideInfo: true,
                          worker: _ctx.getWorkerAvatar(activity.creator_id),
                          size: "small",
                          align: "small"
                        }, null, 8, ["worker"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (activity.creator_avatar_url)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: _normalizeStyle({
                                 backgroundImage: `${_ctx.getAvatarUrlColor(activity.creator_avatar_url, activity.creator_color)}`,
                                 width: `100%`,
                                 height: `100%`,
                                 backgroundSize: `cover`,
                                 backgroundPosition: `center`,
                                 backgroundRepeat: `no-repeat`
                             })
                              }, null, 4))
                            : (_openBlock(), _createBlock(_component_FwIcon, {
                                key: 1,
                                class: "b-worker__avatar__icon",
                                icon: "no-avatar",
                                color: "#fff"
                              }))
                        ])),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, [
                        _createTextVNode(_toDisplayString(activity.creator_role === `manager` ? _ctx.user.account_name : activity.creator_full_name) + " ", 1),
                        _createElementVNode("span", _hoisted_14, [
                          _createTextVNode(_toDisplayString(_ctx.$t(`NOTIFICATION.ACTIVITIES.${activity.kind}`)) + " ", 1),
                          (activity.trackable_fields_changed && activity.kind === `updated`)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.trackable_fields_changed, (itemActivity, key) => {
                                  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(_ctx.$t(_ctx.getActivitiesTrackableItems(itemActivity))) + " " + _toDisplayString(_ctx.fieldChanged(key, activity)), 1))
                                }), 256)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('NOTIFICATION.ACTIVITIES.OF')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" \"" + _toDisplayString(_ctx.$t(_ctx.getTitleOfActivity(activity))) + "\" ", 1)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.getNotificationTime(activity.created_at)), 1)
                    ])
                  ], 10, _hoisted_10))
                }), 256)),
                (_ctx.totalPage > _ctx.perPage)
                  ? (_openBlock(), _createBlock(_component_FwPagination, {
                      key: 0,
                      totalPage: _ctx.totalPage,
                      currentPage: _ctx.currentPage,
                      perPage: _ctx.perPage,
                      value: _ctx.perPage,
                      onGetData: _ctx.getActivities
                    }, null, 8, ["totalPage", "currentPage", "perPage", "value", "onGetData"]))
                  : _createCommentVNode("", true)
              ]))
      ])
    ])
  ]))
}